import backend from '@common/backend';
import { IBookSnapshotIn } from '@common/models/Books/Book';

type getBooksStudentPagesQuery = Partial<{
	book_id: number;
	student_id: number;
	page: number;
	limit: number;
	search: string;
}>;

type IBookStudentPages = {
	book: IBookSnapshotIn;
	id: number;
	page: number;
	progress: string;
	student_id: number;
};

const BASE = '/bookStudentPages';

export const getBooksStudentPages = (query: getBooksStudentPagesQuery) => backend
	.get(`${BASE}`, { params: query })
	.then((booksStudenPages: IBookStudentPages[]) => Object.fromEntries(
		booksStudenPages.map((bookStudenPages) => [
			bookStudenPages.book.id,
			bookStudenPages.progress,
		]),
	));
